import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import { ExportType } from "../../Admin/components/exportModal";
import IRequest from "../../types/services/IRequest";
import IColumnName from "../../types/IColumnName";
import { IPost } from "../../types/services/IPost";
import IThankYouInfo from "../../types/services/IThankYouInfo";
import { PersonalViewSparkType } from "../../Admin/components/thankYouModal";

export const toggleUserProfileModal = (): IAction => ({
  type: actionTypes.USER_PROFILE_MODAL_TOGGLE,
});

export const toggleChangePasswordModal = (): IAction => ({
  type: actionTypes.CHANGE_PASSWORD_MODAL_TOGGLE,
});

export const toggleThankYouModal = (
  thankYouInfos?: Array<IThankYouInfo>,
  modalType?: PersonalViewSparkType,
  goAction?: () => void,
  dismissAction?: () => void,
  skipOkConfirmation?: boolean
): IAction => ({
  type: actionTypes.THANK_YOU_MODAL_TOGGLE,
  payload: {
    thankYouInfos,
    modalType,
    goAction,
    dismissAction,
    skipOkConfirmation,
  },
});

export const toggleEditGiveUrlModal = (
  charityId?: string,
  charityName?: string,
  charityCurrentGiveUrl?: string
): IAction => ({
  type: actionTypes.EDIT_GIVE_URL_MODAL_TOGGLE,
  payload: { charityId, charityName, charityCurrentGiveUrl },
});

export const toggleExportModal = (
  exportType?: ExportType,
  exportIdsArray?: string[],
  exportTotalIds?: string,
  exportFromDate?: number,
  exportToDate?: number,
  ignoreSelected?: boolean,
  donorId?: string,
  exportCharity?: string,
  donorIds?: Array<string>,
  isFlag?: boolean,
  segmentId?: string,
  filterBy?: string,
  summaryExport?: boolean
): IAction => ({
  type: actionTypes.EXPORT_MODAL_TOGGLE,
  payload: {
    exportType,
    exportIdsArray,
    exportTotalIds,
    exportFromDate,
    exportToDate,
    ignoreSelected,
    donorId,
    exportCharity,
    donorIds,
    isFlag,
    segmentId,
    filterBy,
    summaryExport,
  },
});

export const toggleCreateRequestModal = (): IAction => ({
  type: actionTypes.CREATE_REQUEST_MODAL_TOGGLE,
});

export const toggleRequestDetailModal = (request?: IRequest): IAction => ({
  type: actionTypes.REQUEST_DETAIL_MODAL_TOGGLE,
  payload: {
    request,
  },
});

export const toggleColumnsModal = (
  changeColumnFunction?: (index) => void,
  columnNames?: Array<IColumnName>
): IAction => ({
  type: actionTypes.COLUMN_MODAL_TOGGLE,
  payload: {
    changeColumnFunction,
    columnNames,
  },
});

export const columnsModalChange = (columnNames: Array<any>): IAction => ({
  type: actionTypes.COLUMN_MODAL_CHANGE,
  payload: {
    columnNames,
  },
});

export const toggleMediaModal = (
  mediaBlobs?: Array<Blob | string>,
  onlyImage?: boolean,
  hideCustomThumbnail?: boolean,
  customThumbnailUpload?: boolean,
  existingPreviewUrl?: string,
  existingPreviewIsCustom?: boolean,
  postTitle?: string
): IAction => ({
  type: actionTypes.MEDIA_MODAL_TOGGLE,
  payload: {
    mediaBlobs,
    onlyImage: onlyImage === true,
    hideCustomThumbnail: hideCustomThumbnail === true,
    customThumbnailUpload: customThumbnailUpload === true,
    existingPreviewUrl,
    existingPreviewIsCustom: existingPreviewIsCustom === true,
    mediaModalPostTitle: postTitle,
  },
});

/** Drops handed-off media Blobs from the store once the post editor has started their upload. */
export const clearMediaModalBlobs = (): IAction => ({
  type: actionTypes.MEDIA_MODAL_BLOBS_CLEAR,
  payload: {},
});

export const toggleCustomThumbnailModal = (thumbnailBlob: Blob): IAction => ({
  type: actionTypes.CUSTOM_THUMBNAIL_MODAL_TOGGLE,
  payload: {
    thumbnailBlob,
  },
});

export const resetCustomThumbnailModal = (
  thumbnailBlob?: Blob,
  showModal?: boolean
): IAction => ({
  type: actionTypes.RESET_CUSTOM_THUMBNAIL_MODAL,
  payload: {
    thumbnailBlob,
    showModal,
  },
});

export const toggleAddDonorModal = (
  donorFlagId: string,
  donorFlagDonors: Array<string>
): IAction => ({
  type: actionTypes.DONOR_FLAG_MODAL_TOGGLE,
  payload: {
    donorFlagId,
    donorFlagDonors,
  },
});

export const toggleSegmentManagerModal = (
  donorId: string,
  updateComponentFunction?: (index) => void
): IAction => ({
  type: actionTypes.SEGMENT_MANAGER_MODAL_TOGGLE,
  payload: {
    updateComponentFunction,
    donorId,
  },
});

export const togglePostNotificationModal = (post: IPost): IAction => ({
  type: actionTypes.POST_NOTIFICATION_MODAL_TOGGLE,
  payload: {
    post,
  },
});

